import { conditionFormChecker, putField } from "../../../../utils/form";
import { createColumnBoolean, createColumnDate, createColumnInput } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import {
    createFieldCheckbox,
    createFieldDate,
    createFieldInput,
    createFieldInputNumber,
    createFieldSelect
} from "../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";
import { callCountry, callLookup, callUserCeo } from "../../fee/setting-mgt/fee-rate/fee-rate.section";

export const callHazObjectCoordinate = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "refHazObject.isActive", type: "Boolean", operator: "=", value: true },
    ];
    if (searchQuery) {
        where.push({ name: "refHazObject.nameTh", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "refHazObject.refSpecies.value", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "refCoordinateCustoms.name", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/master/hazObjectCoordinate/search", {
            criteria: {
                select: ["**", "refHazObject.refSpecies.*"],
                page: 0,
                size: 1000000,
                where,
                sort: [
                    { name: "refHazObject.nameTh", type: "ASC" },
                    { name: "refHazObject.refSpecies.seq", type: "ASC" },
                    { name: "refCoordinateCustoms.name", type: "ASC" }
                ]
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.riskTopic.name"),
            dataIndex: "name",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.riskTopic.nameS"),
            dataIndex: "nameS",
        }),
        createColumnDate({
            title: () => i18n.global.t("model.riskTopic.startDate"),
            dataIndex: "startDate",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.riskTopic.endDate"),
            dataIndex: "endDate",
            align: "center"
        }),
        createColumnBoolean({
            title: () => i18n.global.t("model.riskTopic.isHighRisk"),
            dataIndex: "isHighRisk"
        }),
        createColumnBoolean({
            title: () => i18n.global.t("model.riskTopic.isMediumRisk"),
            dataIndex: "isMediumRisk"
        }),
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}name`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.name"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.name,
                            "onUpdate:value": value => (model.name = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}nameS`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.nameS"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.nameS,
                            "onUpdate:value": value => (model.nameS = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}startDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.startDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.startDate, "onUpdate:value": value => (model.startDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}endDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.endDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.endDate, "onUpdate:value": value => (model.endDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <hr></hr>
            },
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isHighRisk`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.riskTopic.isHighRisk")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isHighRisk,
                            "onUpdate:checked": checked => {
                                model.isHighRisk = checked;
                                model.isMediumRisk = !checked;
                                if (checked) {
                                    model.inspectCount = null;
                                    model.skipCount = null;
                                }
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isMediumRisk`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.riskTopic.isMediumRisk")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isMediumRisk,
                            "onUpdate:checked": checked => {
                                model.isMediumRisk = checked;
                                model.isHighRisk = !checked;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}inspectCount`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 4 } }),
                label: () => i18n.global.t("model.riskTopic.inspectCount"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.inspectCount,
                            "onUpdate:value": value => (model.inspectCount = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}skipCount`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 4 } }),
                label: () => i18n.global.t("model.riskTopic.skipCount"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.skipCount,
                            "onUpdate:value": value => (model.skipCount = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <hr></hr>
            },
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requestDocs`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.requestDocs"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestDocs,
                            "onUpdate:value": value => (model.requestDocs = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callLookup({ searchQuery, group: "REQUEST_DOC" }).then(items => items.filter(d => ["02", "16", "17", "18", "19"].includes(d.key)).map(item => ({ key: "RequestDoc", refRiskTopicId: model.id, refLookup: item }))),
                            optLabel: "refLookup.value",
                            mode: "multiple",
                            optKey: "refLookup.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}hazSpecies`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.hazSpecies"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.hazSpecies,
                            "onUpdate:value": value => (model.hazSpecies = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callLookup({ searchQuery, group: "HAZ_SPECIES" }).then(items => items.map(item => ({ key: "HazSpecies", refRiskTopicId: model.id, refLookup: item }))),
                            optLabel: "refLookup.value",
                            mode: "multiple",
                            optKey: "refLookup.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}hazObjectCoordinates`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.hazObjectCoordinates"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.hazObjectCoordinates,
                            "onUpdate:value": value => (model.hazObjectCoordinates = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callHazObjectCoordinate({ searchQuery }).then(items => items.map(item => ({ key: "HazObjectCoordinate", refRiskTopicId: model.id, refHazObjectCoordinate: item }))),
                            mode: "multiple",
                            optKey: "refHazObjectCoordinate.id",
                            renderLabel: ({ item }) => {
                                return <span>{item.refHazObjectCoordinate?.refHazObject?.nameTh} - {item.refHazObjectCoordinate?.refHazObject?.refSpecies?.value} ({item.refHazObjectCoordinate?.refCoordinateCustoms?.name})</span>;
                            },
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            // createFieldSelect({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}operations`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.riskTopic.operations"),
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 value: model.operations,
            //                 "onUpdate:value": value => (model.operations = value),
            //                 disabled: viewOnly,
            //                 list: ({ searchQuery }) =>
            //                     callLookup({ searchQuery, group: "USER_OBJECTIVE" }).then(items => items.map(item => ({ key: "Operation", refRiskTopicId: model.id, refLookup: item }))),
            //                 optLabel: "refLookup.value",
            //                 mode: "multiple",
            //                 optKey: "refLookup.id"
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         ),
            // }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}carrySourceCountries`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.carrySourceCountries"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.carrySourceCountries,
                            "onUpdate:value": value => (model.carrySourceCountries = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callCountry({ searchQuery }).then(items => items.map(item => ({ key: "CarrySourceCountry", refFeeRateId: model.id, refCountry: item }))),
                            mode: "multiple",
                            optKey: "refCountry.id",
                            renderLabel: ({ item }) => (<div>{item.refCountry.nameEnS} : {item.refCountry.nameTh}</div>),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}sourceCountries`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.sourceCountries"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.sourceCountries,
                            "onUpdate:value": value => (model.sourceCountries = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callCountry({ searchQuery }).then(items => items.map(item => ({ key: "SourceCountry", refFeeRateId: model.id, refCountry: item }))),
                            mode: "multiple",
                            optKey: "refCountry.id",
                            renderLabel: ({ item }) => (<div>{item.refCountry.nameEnS} : {item.refCountry.nameTh}</div>),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}destinationCountries`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.destinationCountries"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.destinationCountries,
                            "onUpdate:value": value => (model.destinationCountries = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callCountry({ searchQuery }).then(items => items.map(item => ({ key: "DestinationCountry", refFeeRateId: model.id, refCountry: item }))),
                            mode: "multiple",
                            optKey: "refCountry.id",
                            renderLabel: ({ item }) => (<div>{item.refCountry.nameEnS} : {item.refCountry.nameTh}</div>),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}userCompanies`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.riskTopic.userCompanies"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.userCompanies,
                            "onUpdate:value": value => (model.userCompanies = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callUserCeo({ searchQuery }).then(items => items.map(item => ({ key: "UserCompany", refUserCompany: item }))),
                            mode: "multiple",
                            optKey: "refUserCompany.id",
                            renderLabel: ({ item }) => (<div>{item?.refUserCompany?.idCard} {item?.refUserCompany?.fullNameTh}</div>)
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
        ]
    });
};
